import { getThumbnailsUrlsFromList, replaceHtml } from '../../../utils/utils';
import { MediaType } from '../../../constants/MediaType';
export function toItem(settings, data) {
  const snippet = data.snippet;
  const videoId = data.id.videoId;
  function getIframeSrc(videoId) {
    return "//www.youtube.com/embed/" + videoId;
  }
  const availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
    return snippet.thumbnails[prop];
  });
  const urls = getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
  return {
    id: videoId,
    name: replaceHtml(snippet.title),
    iframeSrc: getIframeSrc(videoId),
    folderId: null,
    mediaType: MediaType.Video,
    ...urls
  };
}